/**
 * NotificationCoordinator — singleton that ensures max 1 CRO notification
 * visible at a time, with spacing and per-session caps.
 */

const SESSION_KEY = 'cro_notif_count';
const MAX_PER_SESSION = 3;
const MIN_GAP_MS = 30_000; // 30 seconds between notifications
const INITIAL_DELAY_MS = 10_000; // 10 seconds before first notification

let lastShownAt = 0;
let currentOwner: string | null = null;
const listeners = new Map<string, (allowed: boolean) => void>();
const startTime = Date.now();

function getSessionCount(): number {
  try {
    return parseInt(sessionStorage.getItem(SESSION_KEY) || '0', 10);
  } catch {
    return 0;
  }
}

function incrementSessionCount() {
  try {
    sessionStorage.setItem(SESSION_KEY, String(getSessionCount() + 1));
  } catch {}
}

export function requestSlot(id: string): boolean {
  // Respect initial delay
  if (Date.now() - startTime < INITIAL_DELAY_MS) return false;
  // Session cap
  if (getSessionCount() >= MAX_PER_SESSION) return false;
  // Another notification is showing
  if (currentOwner && currentOwner !== id) return false;
  // Min gap between notifications
  if (Date.now() - lastShownAt < MIN_GAP_MS && currentOwner !== id) return false;

  currentOwner = id;
  lastShownAt = Date.now();
  incrementSessionCount();
  return true;
}

export function releaseSlot(id: string) {
  if (currentOwner === id) {
    currentOwner = null;
  }
}

export function isSlotTaken(excludeId?: string): boolean {
  return currentOwner !== null && currentOwner !== excludeId;
}
